import { useMemo } from "react";

import { Image, Text, useAppPalette, OutlinedChip } from "@bridgesplit/ui";
import { snakeCaseToTitleCase } from "@bridgesplit/utils";
import { getExchangeMeta } from "@bridgesplit/abf-react";

import { ExchangeBadgeProps } from "./types";

export function ExchangeBadge({ exchangeName, loading }: ExchangeBadgeProps) {
    const { isDarkMode } = useAppPalette();
    const exchangeMeta = useMemo(() => getExchangeMeta(exchangeName, isDarkMode), [exchangeName, isDarkMode]);

    if (!exchangeMeta) {
        return (
            <Text variant="caption" color="caption" loading={loading} loadingWidth="60px">
                {snakeCaseToTitleCase(exchangeName)}
            </Text>
        );
    }

    return (
        <OutlinedChip isSelected={false} onClick={() => window.open(exchangeMeta.url, "_blank", "noopener,noreferrer")}>
            <Image src={exchangeMeta.image} variant="circle" size="16px" loading={loading} />
            <Text loadingWidth="30px" variant="caption" color="caption" loading={loading}>
                {exchangeMeta.name}
            </Text>
        </OutlinedChip>
    );
}
